import { Task, ExpectedTaskAnswerMetadata } from "@jelly/lesson";

const items = [{ id: "6d2e3ec5-4748-48ad-ab50-c081a752d924", content: "Tone to Noise Ratio", options: {} }];

const groups = [
  {
    id: "b75414f0-8b5c-49d8-a441-252ec93addc1",
    content: "does not operate with psychoacoustic parameters",
    options: {},
  },
  { id: "5c786440-d9aa-414f-b7d7-25288ba700d3", content: "ignores cavum cochae resonance of the ear", options: {} },
  { id: "f4a997cf-430c-4342-a77d-b3df86b72aca", content: "incompletely implemented", options: {} },
  { id: "cfe0bdaf-55c1-47d7-b2d6-39e87700ce5b", content: "does not give spectral information", options: {} },
  { id: "8b668bc0-f89e-4348-9cb0-127a7a1d3525", content: "can only be used for pure tone analysis", options: {} },
  { id: "122d4391-eb03-4ae6-bcec-2a3ca389bdff", content: "require high frequency resolution", options: {} },
];

export const task: Task = {
  id: "d16fe5be-9335-4d90-8b92-d8c999039e9e",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    shuffle: true,
    multipleConnection: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    { groupId: "b75414f0-8b5c-49d8-a441-252ec93addc1", itemsId: ["6d2e3ec5-4748-48ad-ab50-c081a752d924"] },
    { groupId: "5c786440-d9aa-414f-b7d7-25288ba700d3", itemsId: ["6d2e3ec5-4748-48ad-ab50-c081a752d924"] },
    { groupId: "8b668bc0-f89e-4348-9cb0-127a7a1d3525", itemsId: ["6d2e3ec5-4748-48ad-ab50-c081a752d924"] },
    { groupId: "122d4391-eb03-4ae6-bcec-2a3ca389bdff", itemsId: ["6d2e3ec5-4748-48ad-ab50-c081a752d924"] },
  ],
};
